import { useEffect } from "react";

type useIntersectionObserverProps = {
    isEnabled?: boolean;
    observingElement: HTMLElement | null | undefined;
    options: IntersectionObserverInit;
    onIntersection: (entry: IntersectionObserverEntry) => void;
};

const useIntersectionObserver = ({
    isEnabled = true,
    observingElement,
    options,
    onIntersection,
}: useIntersectionObserverProps) => {
    useEffect(() => {
        if (!observingElement || !isEnabled) {return;}

        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                onIntersection(entry);
            }
        }, options);

        observer.observe(observingElement);

        return () => observer.disconnect();
    }, [observingElement, onIntersection, options, isEnabled]);
};

export default useIntersectionObserver;
